export const getUndos = (state, props) => state.undo;



// WEBPACK FOOTER //
// ./selectors/undo.js